export default "__VITE_ASSET__D$q4TXAS__"